import { PropsWithChildren } from "react";

import cn from "@/helpers/classNames";

type Props = PropsWithChildren<{
  className?: string;
}>;

export default function ActionBar({ children, className }: Props) {
  return (
    <div className="border-t bg-gray-50 dark:bg-background">
      <div
        className={cn(
          `mx-auto flex items-center gap-4 px-8 py-2 md:gap-8 md:py-2`,
          className,
        )}
      >
        {children}
      </div>
    </div>
  );
}
